import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'createEmailTemplate'

export default ({ from, subject, body, templateName }) => (asyncAction(
  name,
  CampaignsService.createEmailTemplate,
  { from, subject, body, name: templateName }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/createEmailTemplate.js